"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ServiceLocator_1 = __importDefault(require("../../utils/ServiceLocator"));
class NotificationServiceImpl {
    constructor() {
        this._listeners = [];
        this.registerEventsOnEmitter = (eventEmitter) => {
            // TODO: Extract those event names to some API file
            eventEmitter.on('progress', this.progressNotification);
            eventEmitter.on('progressCount', this.progressCountNotification);
            eventEmitter.on('progressClear', this.clearProgressNotification);
            eventEmitter.on('error', this.errorNotification);
            eventEmitter.on('warning', this.warningNotification);
        };
        this.deregisterEventsOnEmitter = (eventEmitter) => {
            // TODO: Extract those event names to some API file
            eventEmitter.off('progress', this.progressNotification);
            eventEmitter.off('progressCount', this.progressCountNotification);
            eventEmitter.off('progressClear', this.clearProgressNotification);
            eventEmitter.off('error', this.errorNotification);
            eventEmitter.off('warning', this.warningNotification);
        };
        this.addListener = (callback) => {
            this._listeners.push(callback);
        };
        this.removeListener = (callback) => {
            const index = this._listeners.indexOf(callback);
            if (index < 0) {
                return;
            }
            this._listeners.splice(index, 1);
        };
        this.progressNotification = (progressData) => {
            const newNotification = {
                type: 'progress',
                name: progressData.name,
                message: [
                    `notifications:${progressData.name}`,
                    progressData.customText
                        ? progressData.customText
                        : progressData.progress === null
                            ? 'notifications:pending'
                            : `${Math.round(progressData.progress * 100)}%`
                ],
                done: progressData.progress === 1.0
            };
            this.notifyListeners(newNotification);
        };
        this.progressCountNotification = (progressData) => {
            const newNotification = {
                type: 'progress',
                name: progressData.name,
                message: [
                    `notifications:${progressData.name}`,
                    progressData.customText ? progressData.customText : String(progressData.progress)
                ],
                done: progressData.progress === -1
            };
            this.notifyListeners(newNotification);
        };
        this.clearProgressNotification = (data) => {
            this.notifyListeners({ type: 'clearProgress', name: data.name });
        };
        this.errorNotification = (progressData) => {
            const newNotification = {
                type: 'error',
                name: progressData.name,
                message: [`notifications:${progressData.name}`, `notifications:${progressData.error}`]
            };
            this.notifyListeners(newNotification);
        };
        this.warningNotification = (data) => {
            this.notifyListeners({
                type: 'warning',
                name: data.name,
                message: [`notifications:${data.name}`]
            });
        };
        this.notifyListeners = (notification) => {
            this._listeners.forEach((listener) => listener(notification));
        };
        if (ServiceLocator_1.default.eventManager) {
            this.registerEventsOnEmitter(ServiceLocator_1.default.eventManager);
        }
        if (ServiceLocator_1.default.socketEventManager) {
            this.registerEventsOnEmitter(ServiceLocator_1.default.socketEventManager);
        }
    }
}
exports.default = NotificationServiceImpl;
//# sourceMappingURL=Notifications.js.map